import { FoodCollectionUI } from "@corpuscomplete/core-ui/nutrition/food-collection";
import { RecipeList } from "@corpuscomplete/core-ui/nutrition/recipe/list";
import { RecipesPage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipes";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/recipes/")({
  validateSearch: z.object({
    collectionId: z.uuid().optional(),
  }),
  loaderDeps: ({ search: { collectionId } }) => ({ collectionId }),
  loader: async ({ context: { zero }, deps: { collectionId }, params: { spaceId } }) => {
    if (!zero) return;
    await RecipeList.preload(zero, { requestedCollectionId: collectionId, scopeId: spaceId });
  },
  component: () => {
    const { collectionId: requestedCollectionId } = Route.useSearch();
    const { spaceId } = Route.useParams();
    const collections = FoodCollectionUI.useForContentManagement({ foodType: "recipe" }).filter(
      (collection) => collection.scopeId === spaceId,
    );
    const collectionId = FoodCollectionUI.resolveManagedCollectionId({
      requestedCollectionId,
      collections,
      foodType: "recipe",
    });

    if (collectionId !== requestedCollectionId) {
      return (
        <Navigate
          to="/spaces/$spaceId/recipes"
          params={{ spaceId }}
          search={{ collectionId }}
          replace
        />
      );
    }

    return <RecipesPage collectionId={collectionId} scope={{ kind: "space", spaceId }} />;
  },
});
